<template>
<div>
  <div class="recruit">
    <div class="box" v-bind:style="background">
      <Title :title="title" :message="message"/>
    </div>
    <div class="news">
      <div class="news_title">
        <h1>採用News</h1>
      </div>
      <div class="news_contents">
        <p class="day">2024/3</p>
        <p class="info">観光バス運転士を積極的に募集しています。まずはお気軽にお問い合わせください。</p>
      </div>
    </div>
    <div class="contents">
      <div class="content-title">
        <h1>当社運転士に聞く「当社の魅力」</h1>
        <p>※自社運転士に対するヒアリング</p>
      </div>
      <div class="container-fluid content">
        <div class="row">
          <div class="col-xs-12 col-lg-7 resizeimage">
            <img src="@/assets/driver-1.png"/>
          </div>
          <div class="col-xs-12 col-lg-5 order-md-first resizeimage disc">
            <div class="table-container">
            <div class="table-title text">
                <h2>1. 当社の特徴</h2>
              </div>
              <table class="table">
                <tbody>
                  <tr>
                    <td class="text">業務内容は観光仕業がほとんどです。<br>学生（小・中・高）、法人ツアー（羽田受け、東京駅受け、新横浜駅受け等の2泊3日が多い）、一般観光団体が中心で、インバウンドはコースや時間がしっかりしていて駐車場所が確保されている大手国内旅行会社経由のもののみ行っていますが数量はわずかです。<br>年間契約などの送迎はありません。また、都市間高速路線をはじめとする路線バスはやっていません。夜行の仕業は年間を通してほぼゼロです。<br>拘束時間は秋のシーズンで1週平均57.6時間、オフシーズンで25.3時間、年間平均39.1時間。運転時間は秋のシーズンで1週平均32.5時間、オフシーズンで15.2時間、年間平均22.4時間。走行距離は月間平均4,021kmです。昨秋のハイシーズン10月・11月での残業時間は月平均16時間12分でした。</td>
                  </tr>
                </tbody>
              </table>
              <div class="table-title text">
                <h2>2. 先輩後輩のしがらみがなく、仕事がしやすい環境</h2>
              </div>
              <table class="table">
                <tbody>
                  <tr>
                    <td class="text">当社で働く運転士の圧倒的多数が「仲の良さ」を魅力に挙げています。<br>例えば入庫後、洗車機に入れる順番は台数口であっでも入庫順で、先輩を待つ必要なんて一切ありません。バス業界にはさまざまな風習がありますが、東栄観光バスには古い慣習を時代に合わせて変えることが出来る人々が集まっています。今回は運転士で運転定年(65歳)を迎えた方が3名いて、車庫内運転士等にまわったため、募集をおこなっています。<br>なお、60歳以上の方には小型またはコミューター限定での観光業務も考えています。<br>また、男性運転士での育児休業取得実績もあります。</td>
                  </tr>
                </tbody>
              </table>
              <div class="table-title text">
                <h2>3. 大多数が中二階バス、高性能洗車機が設置されている</h2>
              </div>
              <table class="table">
                <tbody>
                  <tr>
                    <td class="text">車両設備に積極投資しており、大型車・中型車は全車現行型の日野J-BUSを使用し、しかも大型車の約70％が中二階車両です。なお、バスについては担当車制を導入しており、現在は中二階車両の空きもあるため入社後すぐに中二階車両への乗務も可能です。また、運転士の負担を考え、拭き取り作業を大幅に軽減できる、乾燥機能付きダイクマ製の高性能門型自動洗車機をさいたま営業所と横浜営業所に設置しています。<br>さらに、車庫帰着後の車内清掃は各営業所共専門の車内清掃員がいるため、早帰りを除いて原則としてありません。（週1日指定曜日は清掃あり）<br>車庫はもちろん全舗装、東京営業所を除いて車庫内の車両入れ替えはありません。また、小型を除くすべての車両に軽量チェーンを装備。運転士の負担を大幅に軽減しています。</td>
                  </tr>
                </tbody>
              </table>
              <div class="table-title text">
                <h2>4. 入社から一人立ちまでの教育研修がしっかりしている</h2>
              </div>
              <table class="table">
                <tbody>
                  <tr>
                    <td class="text">実地訓練のみならず、机上教育にもしっかりと時間を費やします。<br>例えば貸切バス未経験者の場合には、法令で定める以上の時間をかけて、運転法規・車両特性・地理などについて、机上・実技を織り交ぜながら訓練をします。また、当社でよく行く経路として、日光・箱根・都内などの重要ルートについても指導担当が同乗して運転のポイントを指導します。実際の一人乗務を開始するまでに要する訓練期間は約2ヶ月です。加えて、一人立ちしてからも、当分の間は台数口の中に入り、前後の車両から無線により後輩をサポートします。また、定期的に指導者から指導を受けたり、分からないことは先輩に聞くと快く教えてくれます。熱意のある先輩社員がしっかりサポートして実施しますので、大型未経験でも安心です。<br>今、路線バスに乗っている人も、もっと大型で、あらゆるドライバーの中で最高峰の観光バスの運転士をやってみませんか？</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid content">
        <div class="row">
          <div class="col-xs-12 col-lg-7 resizeimage">
            <img src="@/assets/driver-2.png"/>
          </div>
          <div class="col-xs-12 col-lg-5 resizeimage disc">
            <div class="table-container">
              <div class="table-title text">
                <h2>5. 観光バス以外の事業も行っているため災害に強い</h2>
              </div>
              <table class="table">
                <tbody>
                  <tr>
                    <td class="text">
                    <p>私たちの会社は社歴55年以上。大型貨物や工事プラントなど、多角的に事業を行っています。観光バス事業がコロナなどの影響を受けても、他の事業でカバーすることでリストラや給与カットをせず、長年安定した経営を行ってきました。<br>例えば今回のコロナでは、大型トラックの運転が出来る人は、月に数回大型トラックに乗務したり、運転が出来ない他の人は、乗用車で大型トレーラーの誘導車運転をしたり、また道路工事用の仕材の積み込み作業の手伝いを行い、バス運転士の手当維持を計りました。その結果、コロナ禍においてもコロナを理由に退職した人は1人もいませんでした。</p>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="table-title text">
                <h2>6. 全社員が熱意を持って仕事に取り組んでいる</h2>
              </div>
              <table class="table">
                <tbody>
                  <tr>
                    <td class="text">
                    <p>例えば、当社の営業社員は日々新しい仕事の確保に努めており、コロナ禍で仕業が少ない間もオリンピック輸送・ワクチンバス・企業送迎など、いくつもの仕事を獲得してきました。また、運行管理部門の社員は事故や車両の故障を起こさないよう、毎週すべての拠点の担当者が集まり、運行会議を行っています。<br>2025年春現在、コロナ前にまで業界の需要は回復しています。そこで当社では運転士を増員することによってバス部全体の売上を伸ばし、運転士の更なる賃金UPに繋げていこうと考えています。</p>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="table-title text">
                <h2>7. 1年以上勤めた人で退職者はほとんどいない</h2>
              </div>
              <table class="table">
                <tbody>
                  <tr>
                    <td class="text">
                    <p>当社は細かな規則もちゃんと決まっているし、まじめな人が多いので水が合えば辞める人はいません。水が合わない人は申し訳ありませんが入社後比較的早い段階で去っていきます。</p>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="table-title text">
                <h2>8. 運転士の待遇が良い</h2>
              </div>
              <table class="table">
                <tbody>
                  <tr>
                    <td class="text">
                    <p>＜横浜営業所の例＞<br>➀入社1年後の平均年収：4,999,148~5,661,940円<br>（路線バス～貸切バス経験者）<br>➁5年勤務者の平均年収：6,074,834~6,171,818円<br>（※本年予測値）<br>③入社後研修中（1～6か月）の月収：約280,000~310,000円<br>※研修課程の進捗により順次アップしていきます。<br>➃中小型バス限定運転者の平均年収：4,753,556円</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="table_container">
      <div class="table_title">募集要項</div>
      <table class="table">
        <tbody>
          <tr>
            <th>職種・雇用形態</th>
            <td>観光バス運転士（正社員）<br>※観光バス/路線バス/送迎バス/大型トラック経験者に限る<br>これらの経験がない方はご相談ください</td>
          </tr>
          <tr>
            <th>給与</th>
            <td>月310,100～504,000円  <br>（観光シーズンによる変動です）</td>
          </tr>
          <tr>
            <th>勤務時間・休日</th>
            <td>8：00～17：00 ※変動あり<br>週休二日制</td>
          </tr>
          <tr>
              <th>昇給</th>
              <td>年1回</td>
          </tr>
          <tr>
              <th>賞与</th>
              <td>年2回</td>
            </tr>
            <tr>
              <th>福利厚生・手当</th>
              <td>通勤手当・退職金制度・有給休暇・諸手当<br>独身寮（通勤できない場合のみ・一部自己負担）</td>
            </tr>
            <tr>
              <th>社会保険</th>
              <td>健康保険・厚生年金保険・雇用保険・労災保険</td>
            </tr>
            <tr>
            <th>必須資格</th>
            <td>大型二種免許</td>
            </tr>
            <tr>
              <th>勤務地</th>
              <td>さいたま第二営業所（さいたま市岩槻区）<br>横浜営業所（横浜市港北区）<br>東京営業所（東京都板橋区）</td>
            </tr>
        </tbody>
      </table>
    </div>
    <div class="contact">
      <div class="contact-title">
        <h1>お問い合わせ先</h1>
      </div>
      <div class="contact-content">
        <p>各営業所の採用担当までご連絡ください。</p>
      </div>
      <div class="contact-container">
        <div class="row office-box">
          <div class="col-xs-12 col-lg-6 contact">
            <span>さいたま第二営業所</span>
            〒339-0011 埼玉県さいたま市岩槻区長宮94
            <a href="tel:048-799-1214">T:048-799-1214</a>
          </div>
          <div class="col-xs-12 col-lg-6 contact">
            <span>横浜営業所</span>
            〒223-0057 神奈川県横浜市港北区新羽町1187
            <a href="tel:045-540-2710">T:045-540-2710</a>
          </div>
          <div class="col-xs-12 col-lg-6 contact">
            <span>東京営業所</span>
            〒174-0051 東京都板橋区小豆沢2-3-11
            <a href="tel:03-3965-0556">T:03-3965-0556</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Title from '@/components/Title.vue'

export default {
  components: {
    Title
  },
  data () {
    return {
      background: {
        background: '',
        position: 'relative',
        height: '100vh',
        minHeight: '300px',
        backgroundSize: 'cover',

        display: 'flex',
        flexDirection: 'column',

        letterSpacing: '0',
        color: '#FFFFFF'
      },
      title: 'DRIVER',
      message: '業界最高ランクの安全品質を保つ、安心して働ける会社'
    }
  },
  created () {
    this.background.background = "url('" + require('../assets/driver-top-2.jpg') + "') no-repeat 55% 60%"
  }
}
</script>

<style scoped>
.recruit {
  overflow:hidden;
}
.news{
  padding:2% 4% 4% 4%;
}
.news h1 {
  font-size:32px;
  font-weight:bold;
  padding:20px 15px;
  margin:0px;
  color:#000000;
  border-bottom-style:solid;
  border-bottom-width:1px;
  border-bottom-color:#a6a6a6;
}
.news_contents {
  padding:10px 15px;
  border-bottom-style:solid;
  border-bottom-width:1px;
  border-bottom-color:#a6a6a6;
  display:flex;
  margin:0;
}
.day {
  font-size:16px;
  font-weight:bold;
  padding-right:20px;
}
.info {
  font-size:16px;
}
img {
  width: 100%;
}
.works-image {
  text-align:end;
}
.contents {
  padding:2% 4% 4% 4%;
}
.content-title {
  border-bottom-style:solid;
  border-bottom-width:1px;
  border-bottom-color:#a6a6a6;
  margin-bottom:20px;
}
.content-title h1 {
  font-size:32px;
  font-weight:bold;
  padding:20px 15px;
  margin:0px;
  color:#000000;
}
h2 {
  font-size:24px;
  font-weight:bold;
  padding-top:20px;
}
.content-title p {
  display:inline;
  padding-left:15px;
}
.table_container {
  padding:2% 4% 4% 4%;
}
.table {
  white-space:pre-line;
}
table td {
  width:70%;
}
.table_title {
  color:#000000;
  font-size:32px;
  font-weight:bold;
  padding-bottom:20px;
}
.contact {
  padding:2% 4% 4% 4%;
  color:#303030;
}
.contact-title h1 {
  font-size:32px;
  font-weight:bold;
  padding:20px 15px;
  margin:0px;
  color:#000000;
  border-bottom-style:solid;
  border-bottom-width:1px;
  border-bottom-color:#a6a6a6;
}
.contact-content p{
  padding:10px 15px;
}
.contact-container {
  padding-top: 40px;
  padding-bottom: 40px;
  white-space: pre-line;
  position: relative;
}
.contact {
  padding-top: 12px;
  padding-bottom: 12px;
}
.contact span {
  font-size: 16px;
  font-weight: bold;
  color: #000000;
}
.office-box {
  padding: 0px 10% 0px 12%;
}

</style>



// WEBPACK FOOTER //
// src/components/RecruitDriver.vue